<template lang='pug'>
//- Team-Page
div(:class='$style[`cc-team`]')
  div(v-if='!preloading' :class='$style[`cc-team-main`]')
    //- 左邊大頭貼
    div(:class='$style[`cc-team-main-left`]')
      TeamProfile(
        :dataTeam='teamStatus'
        :tmid='`${teamStatus.id}`'
        :isBookmarked='checkIfDataMatched(teamStatus.addbookmark)')

      //- 中間內容區
      div(:class='$style[`cc-team-wrap`]')
        //- div(v-if='teamStatus.banner' :class='$style[`cc-team-wrap-banner`]')
        //-   img(:src='`${SERVER_STATIC_URL}media/team/thumb/banner_1.webp`' width='100%' height='100%')
        div(:class='$style[`cc-team-wrap-menu`]')
          //- router-link(
          //-   v-if='teamStatus.member.length'
          //-   role='button'
          //-   tabindex='0'
          //-   aria-label='組織成員'
          //-   :active-class='$style[`js-selected`]'
          //-   :class='$style[`cc-team-wrap-menu-nav`]'
          //-   :to='`/team/${teamStatus.id}#member`' replace)
          //-   span!= '組織成員'

          router-link(
            v-if='teamStatus.intro' 
            role='button'
            tabindex='0'
            aria-label='簡介'
            :active-class='$style[`js-selected`]'
            :class='$style[`cc-team-wrap-menu-nav`]'
            :to='`/team/${teamStatus.id}#intro`' replace)
            span!= '簡介'

          router-link(
            v-if='teamStatus.service'
            role='button'
            tabindex='0'
            aria-label='服務項目'
            :active-class='$style[`js-selected`]'
            :class='$style[`cc-team-wrap-menu-nav`]'
            :to='`/team/${teamStatus.id}#service`' replace)
            span!= '服務'
              span.no-wrap!= '項目'

          router-link(
            v-if='teamStatus.ideal'
            role='button'
            tabindex='0'
            aria-label='適合對象'
            :active-class='$style[`js-selected`]'
            :class='$style[`cc-team-wrap-menu-nav`]'
            :to='`/team/${teamStatus.id}#ideal`' replace)
            span!= '適合'
              span.no-wrap!= '對象'

          router-link(
            v-if='teamStatus.contact'
            role='button'
            tabindex='0'
            aria-label='更多資訊'
            :active-class='$style[`js-selected`]'
            :class='$style[`cc-team-wrap-menu-nav`]'
            :to='`/team/${teamStatus.id}#contact`' replace)
            span!= '更多'
              span.no-wrap!= '資訊'

        //- 文章內文
        div(:class='$style[`cc-team-wrap-container`]')
          //- div(:class='$style[`cc-team-wrap-tag`]')
          //-   ul(:class='$style[`cc-team-wrap-tag-ul`]')
          //-     li(:class='$style[`cc-team-wrap-tag-li`]')
          //-       router-link(:class='$style[`cc-team-wrap-tag-link`]' :to='`/team/${teamStatus.id}`')!= '乳癌'
          //-     li(:class='$style[`cc-team-wrap-tag-li`]')
          //-       router-link(:class='$style[`cc-team-wrap-tag-link`]' :to='`/index`')!= '乳癌'
          //-     li(:class='$style[`cc-team-wrap-tag-li`]')
          //-       router-link(:class='$style[`cc-team-wrap-tag-link`]' :to='`/index`')!= '乳癌'
          //-     li(:class='$style[`cc-team-wrap-tag-li`]')
          //-       router-link(:class='$style[`cc-team-wrap-tag-link`]' :to='`/index`')!= '乳癌'

          //- section(v-if='teamStatus.member.length' id='member' :class='$style[`cc-team-wrap-section`]')
          //-   h2.font-medium(:class='$style[`cc-team-wrap-section-title`]')!= '組織成員'
          //-   div(:class='$style[`cc-team-wrap-section-inner`]')
          //-     ul(:class='$style[`cc-team-wrap-section-member-ul`]')
          //-       li(v-for='items, index in teamStatus.member' :key='index' :class='$style[`cc-team-wrap-section-member-li`]')
          //-         router-link(
          //-           role='button'
          //-           tabindex='0'
          //-           aria-label='查看個人檔案'
          //-           :class='$style[`cc-team-wrap-section-member-link`]' :to='{ name: `profile-detail`, params: { type: `${items.user_type}`, id: `${items.auth_id}` }}')
          //-           div(v-if='items.user_type === `doctor`')
          //-             figure(v-if='items.thumbSrc === ``' :class='$style[`cc-team-wrap-section-member-avatar`]')
          //-               div(:class='$style[`cc-team-wrap-section-member-mask`]')
          //-                 span!= '查看'
          //-               //- Doctor-Male-Avatar
          //-               img(
          //-                 v-if='items.gender === `0`'
          //-                 :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
          //-                 width='100%'
          //-                 height='100%')
          //-               //- Doctor-Female-Avatar
          //-               img(
          //-                 v-else
          //-                 :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
          //-                 width='100%'
          //-                 height='100%')

          //-             figure(v-else :class='$style[`cc-team-wrap-section-member-avatar`]')
          //-               div(:class='$style[`cc-team-wrap-section-member-mask`]')
          //-                 span!= '查看'
          //-               img(
          //-                 :src='`${SERVER_STATIC_URL}media/${items.thumbSrc}`'
          //-                 width='100%'
          //-                 height='100%')

          //-             div.font-medium(:class='$style[`cc-team-wrap-section-member-name`]')
          //-               span.font-doctor-theme {{ `${items.firstName}${items.lastName}` }}


          //-           div(v-if='items.user_type === `normal`')
          //-             figure(v-if='items.thumbSrc === `` && !items.public' :class='$style[`cc-team-wrap-section-member-avatar`]')
          //-               div(:class='$style[`cc-team-wrap-section-member-mask`]')
          //-                 span!= '查看'
          //-               img(
          //-                 v-if='items.gender === `0`'
          //-                 :src='`${STATIC_URL}images/common/user/normal_male.webp`'
          //-                 width='100%'
          //-                 height='100%')
          //-               img(
          //-                 v-else
          //-                 :src='`${STATIC_URL}images/common/user/normal_female.webp`'
          //-                 width='100%'
          //-                 height='100%')

          //-             figure(v-else-if='items.thumbSrc !== `` && !items.public' :class='$style[`cc-team-wrap-section-member-avatar`]')
          //-               div(:class='$style[`cc-team-wrap-section-member-mask`]')
          //-                 span!= '查看'
          //-               img(
          //-                 v-if='items.gender === `0`'
          //-                 :src='`${STATIC_URL}images/common/user/normal_male.webp`'
          //-                 width='100%'
          //-                 height='100%')
          //-               img(
          //-                 v-else
          //-                 :src='`${STATIC_URL}images/common/user/normal_female.webp`'
          //-                 width='100%'
          //-                 height='100%')

          //-             figure(v-else-if='items.thumbSrc === `` && items.public' :class='$style[`cc-team-wrap-section-member-avatar`]')
          //-               div(:class='$style[`cc-team-wrap-section-member-mask`]')
          //-                 span!= '查看'
          //-               img(
          //-                 v-if='items.gender === `0`'
          //-                 :src='`${STATIC_URL}images/common/user/normal_male.webp`'
          //-                 width='100%'
          //-                 height='100%')
          //-               img(
          //-                 v-else
          //-                 :src='`${STATIC_URL}images/common/user/normal_female.webp`'
          //-                 width='100%'
          //-                 height='100%')

          //-             figure(v-else-if='items.thumbSrc !== `` && items.public'
          //-             :class='$style[`cc-team-wrap-section-member-avatar`]')
          //-               div(:class='$style[`cc-team-wrap-section-member-mask`]')
          //-                 span!= '查看'
          //-               img(
          //-                 :src='`${SERVER_STATIC_URL}media/${items.thumbSrc}`'
          //-                 width='100%'
          //-                 height='100%')

          //-             div.font-medium(:class='$style[`cc-team-wrap-section-member-name`]')
          //-               span.font-normal-theme(
          //-                 v-if='items.public ===`yes`'
          //-               ) {{ items.gender === `0` ? `${items.firstName}${items.lastName}` : `${items.firstName}${items.lastName}` }}
          //-               span.font-normal-theme(
          //-                 v-else
          //-               ) {{ items.gender === `0` ? `${items.firstName}先生` : `${items.firstName}小姐` }}


          section(v-if='teamStatus.intro' id='intro' :class='$style[`cc-team-wrap-section`]')
            h2.font-medium(:class='$style[`cc-team-wrap-section-title`]')!= '簡介'
            div(:class='$style[`cc-team-wrap-section-inner`]' v-html='teamStatus.intro')

          section(v-if='teamStatus.service' id='service' :class='$style[`cc-team-wrap-section`]')
            h2.font-medium(:class='$style[`cc-team-wrap-section-title`]')!= '服務項目'
            div(:class='$style[`cc-team-wrap-section-inner`]' v-html='teamStatus.service')

          section(v-if='teamStatus.ideal' id='ideal' :class='$style[`cc-team-wrap-section`]')
            h2.font-medium(:class='$style[`cc-team-wrap-section-title`]')!= '適合對象'
            div(:class='$style[`cc-team-wrap-section-inner`]' v-html='teamStatus.ideal')

          section(v-if='teamStatus.contact' id='contact' :class='$style[`cc-team-wrap-section`]')
            h2.font-medium(:class='$style[`cc-team-wrap-section-title`]')!= '更多資訊'
            div(:class='$style[`cc-team-wrap-section-inner`]' v-html='teamStatus.contact')
            div(v-if='teamStatus.photo' v-swiper:upgradeSwiper='swiperOption' :class='$style[`cc-team-wrap-photo`]')
              ul(:class='[`swiper-wrapper`, $style[`cc-team-wrap-photo-ul`]]')
                li(v-for='items, index in photoJsonParse' :key='index' :class='[`swiper-slide`, $style[`cc-team-wrap-photo-li`]]' :title='`乳癌術後酸麻脹痛，復健照護馬上來`')
                  figure(:class='$style[`cc-team-wrap-photo-thumb`]')
                    img(:src='`${STATIC_URL}${items}`' width='100%')
              div(:class='[`swiper-pagination`, $style[`cc-team-wrap-photo-pagination`]]')


    //- 右側服務項目
    div(:class='$style[`cc-team-main-right`]')
      div(:class='$style[`cc-team-side`]')
        div(:class='$style[`cc-team-side-wrap`]')
          div(:class='$style[`cc-team-side-container`]')
            span.font-medium(:class='$style[`cc-team-side-title`]')!= '提供的服務'
            span(:class='$style[`cc-team-side-info`]')!= '實際服務內容請以單位網站說明為主'
            ul(:class='$style[`cc-team-side-ul`]')
              li(v-for='items, index in teamStatus.feature' :key='index' :class='$style[`cc-team-side-li`]')
                a(:class='$style[`cc-team-side-link`]' :href='items.link') {{ items.feature_name }}
          div(:class='$style[`cc-team-side-counter`]')
            span {{ `瀏覽次數 ${teamStatus.read}` }}

    div(:class='$style[`cc-team-mobile-feature`]')
      span.font-medium(:class='$style[`cc-team-mobile-title`]')!= '提供的服務'
      span(:class='$style[`cc-team-mobile-info`]')!= '實際服務內容請以單位網站說明為主'
      a(:class='$style[`cc-team-mobile-link`]' href='javascript:;' @click='handleShowTeamFeaturePopBox') {{ '查看所有服務' }}

  //- Preloader Container
  div(v-else :class='$style[`cc-preloader-content`]')
    div(:class='$style[`cc-team-wrap`]')
      div(:class='$style[`cc-team-wrap-left`]')
        div(:class='$style[`cc-team-wrap-profile`]')
          div.skeleton-preload(:class='$style[`cc-team-profile-avatar`]')
          div.skeleton-preload(:class='$style[`cc-team-profile-title`]')
          div.skeleton-preload(:class='$style[`cc-team-profile-info`]')
        div(:class='$style[`cc-team-wrap-main`]')
          div.skeleton-preload(:class='$style[`cc-team-main-banner`]')
          div.skeleton-preload(:class='$style[`cc-team-main-title`]')
          div.skeleton-preload(:class='$style[`cc-team-main-info`]')

      div(:class='$style[`cc-team-wrap-right`]')
        div(:class='$style[`cc-team-wrap-side`]')
          div.skeleton-preload(:class='$style[`cc-team-side-title`]')
          div.skeleton-preload(:class='$style[`cc-team-side-link`]')
          div.skeleton-preload(:class='$style[`cc-team-side-link`]')


</template>

<script>
// import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';
import { directive } from 'vue-awesome-swiper';
// import { mixin as clickaway } from 'vue-clickaway';
// import { debounce } from 'debounce';
import TeamProfile from './TeamProfile';

import {
  getLoadNpoProfile,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: `${this.teamStatus.name}`,
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: `https://cancell.tw/team/${this.teamStatus.id}`,
      }],
      link: [{
        rel: 'canonical',
        href: `https://cancell.tw/team/${this.teamStatus.id}`,
      }],
    };
  },

  components: {
    TeamProfile,
  },

  directives: {
    swiper: directive,
  },

  // mixins: [clickaway],

  data() {
    return {
      // tmid: this.$route.params.teamId,
      preloading: true,

      // scrollTop: 0,
      teamStatus: {},
      // nextTick: 1,

      swiperOption: {
        spaceBetween: 10,
        threshold: 20,
        slidesPerView: 3,
        slidesPerGroup: 1,
        loop: false,
        loopFillGroupWithBlank: true,
        edgeSwipeThreshold: 100,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1280: {
            spaceBetween: 10,
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          960: {
            spaceBetween: 30,
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          731: {
            spaceBetween: 30,
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          500: {
            spaceBetween: 20,
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          0: {
            spaceBetween: 20,
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
        },
      },

      // infiniteId: +new Date(),
    };
  },

  created() {
    this.handleTeamFirstLoad(this.$route.params.teamId);
  },

  // mounted() {
  //   window.addEventListener('scroll', this.handleMenuNavScroll);
  // },

  methods: {
    ...mapMutations({
      changeTeamFeatureStatus: 'global/POPTEAM_FEATURE_STATUS',
    }),

    // initSectionOffsetTop() {
    // },

    handleTeamFirstLoad(teamId) {
      getLoadNpoProfile(`/?pk=${teamId}`)
        .then((res) => {
          console.log('getLoadNpoProfile', res.data);

          if (res.data === 'no data') {
            this.$router.replace({
              name: 'error404',
            }).catch(() => true);
          } else {
            this.teamStatus = res.data;
            this.preloading = false;
          }

        })
        .catch((error) => {
          console.log('handleRouterTypeOnLoad Error: ', error.response);
          this.$router.replace({
            name: 'error404',
          }).catch(() => true);
        })
    },

    handleShowTeamFeaturePopBox() {
      this.changeTeamFeatureStatus({
        active: true,
        features: this.teamStatus.feature,
      });
    },

    // handleMenuNavScroll() {
    //   this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

    //   console.log('ScrollTop', this.scrollTop);
    // },

    // initReadCountNumber(num) {
    //   // eslint-disable-next-line no-unused-expressions
    //   return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    // },

    checkIfDataMatched(recieveData) {
      // console.log('CheckData', recieveData, this.loginDjangoId);
      return recieveData.includes(this.loginDjangoId);
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
    //   loginStatus: 'user/exportLoginStatus',
    //   loginProfile: 'user/exportUserProfile',
    //   // stateFlowBarFixed: 'global/exportFlowBarFixed',
    //   authJwtToken: 'user/exportUserJwtToken',
    }),

    photoJsonParse() {
      return JSON.parse(this.teamStatus.photo);
    },
  },

  // eslint-disable-next-line vue/order-in-components
  // watch: {
  //   updateTick() {
  //     this.replyData = [];
  //     this.axiosLoadReplyData();
  //   },

  //   $route(to, from) {
  //     if (to.name === 'qa-detail') {
  //       this.axiosLoadScoopStatus();
  //       this.axiosLoadReplyData();
  //     }
  //   },
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/team/team.scss';
</style>
